import { render, staticRenderFns } from "./FooterMain.vue?vue&type=template&id=0c72f0c3&scoped=true"
import script from "./FooterMain.vue?vue&type=script&lang=js"
export * from "./FooterMain.vue?vue&type=script&lang=js"
import style0 from "./FooterMain.vue?vue&type=style&index=0&id=0c72f0c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c72f0c3",
  null
  
)

export default component.exports